import { dateFormat } from '../utils/formatter'

export const candidateReferencesCols = [
  {
    accessorKey: 'SEQUENCENUMBER',
    header: 'Seq',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1
  },
  {
    accessorKey: 'REFERENCE_NAME',
    header: 'Reference',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'RELATIONSHIP',
    header: 'Relationship',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'CITNSUBSCRIBERNUMBER',
    header: 'Phone Number',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1
  },
  {
    accessorKey: 'CIEMAILADDRESS',
    header: 'Email',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1
  },
  {
    accessorKey: 'REFERENCESTATUS',
    header: 'Status',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  }
]

export const candidateRequisitionsCols = [
  {
    accessorKey: 'REQUISITION',
    header: 'Requisition',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'DESCRIPTION',
    header: 'Title',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'LOCATION',
    header: 'Location',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'HIRING_MANAGER',
    header: 'Hiring Manager',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'APPLICATIONDATE',
    header: 'Application Date',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  },
  {
    accessorKey: 'CANDIDATE_TYPE',
    header: 'Type',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'SOURCE',
    header: 'Source',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'OFFERDATE',
    header: 'Offer Date',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  }
]

export const candidateLicensesCols = [
  {
    accessorKey: 'CREDENTIAL_DESCRIPTION',
    header: 'Credential',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'QUALIFICATIONSOURCE',
    header: 'Source',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'DREND',
    header: 'Expire Date',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  },
  {
    accessorKey: 'VALIDATED',
    header: 'Validated',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'VIVERIFICATIONDATE',
    header: 'Validation Date',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  },
  {
    accessorKey: 'DRBEGIN',
    header: 'Date Received',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  },
  {
    accessorKey: 'CREDENTIALNUMBER',
    header: 'Credential Number',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  }
]

export const candidateCompetenciesCols = [
  {
    accessorKey: 'COMPETENCY',
    header: 'Competency/Skill',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'QUALIFICATIONSOURCE',
    header: 'Source',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'DATEACQUIRED',
    header: 'Date Acquired',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  },
  {
    accessorKey: 'RATINGLEVEL',
    header: 'Rating',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'VALIDATED',
    header: 'Validated',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'VIVERIFICATIONDATE',
    header: 'Validation Date',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  }
]

export const candidateEducationCols = [
  {
    accessorKey: 'EDUCATION',
    header: 'Education',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'SPECIALIZATION',
    header: 'Specialization',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'INSTITUTION',
    header: 'Institution',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'COMPLETION_DATE',
    header: 'Completion Date',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  },
  {
    accessorKey: 'IN_PROCESS',
    header: 'In Process',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'VALIDATED',
    header: 'Validated',
    enableSorting: false,
    enableColumnFilter: true,
    size: 1
  },
  {
    accessorKey: 'VIVERIFICATIONDATE',
    header: 'Validation Date',
    enableSorting: false,
    enableColumnFilter: false,
    size: 1,
    Cell: ({ cell }) => dateFormat(cell.getValue())
  }
]
